var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalLinkButton',{staticClass:"ta-auction-important-information-link",attrs:{"title":_vm.$t('Important Information'),"content":_vm.importantInfo}})}
var staticRenderFns = []

export { render, staticRenderFns }